import { Plot } from '../../core/plot';
import { deepAssign } from '../../utils';

export const BOX_RANGE = '$$range$$';
export const BOX_RANGE_ALIAS = 'low-q1-median-q3-high';

export const BOX_SYNC_NAME = '$$y_outliers$$';

export const OUTLIERS_VIEW_ID = 'outliers_view';

/**
 * é¢ç§¯å¾é»è®¤éç½®é¡¹
 */
export const DEFAULT_OPTIONS = deepAssign({}, Plot.getDefaultOptions(), {
  meta: {
    [BOX_RANGE]: { min: 0, alias: BOX_RANGE_ALIAS },
  },

  // é»è®¤åºåäº¤äº
  interactions: [{ type: 'active-region' }],

  // é»è®¤ tooltips å±äº«ï¼ä¸æ¾ç¤º markers
  tooltip: {
    showMarkers: false,
    shared: true,
  },
  boxStyle: {
    lineWidth: 1,
  },
});
